// @flow

export const isErrorMessage = (value?: ?string | Dict) =>
  (typeof value === "string" && value !== "") || typeof value === "object";
